/**
 * Breadcrumbs for the reservations module.
 * @type {Array}
 */
export const BREAD_RESERVATIONS = [
    {
        text: "Dashboard",
        to: "/dashboard"
    },

    {
        text: "Reservations",
        active: true
    }
]

/**
 * Breadcrumbs for the new reservation page.
 * @type {Array}
 */
export const BREAD_NEW_RESERVATION = [
    {
        text: "Dashboard",
        to: "/dashboard"
    },
    {
        text: "Reservations",
        to: "/reservations"
    },
    {
        text: "New Reservation",
        active: true
    }
]

/**
 * Breadcrumbs for the edit reservation page.
 * @type {Array}
 */
export const BREAD_EDIT_RESERVATION = [
    {
        text: "Dashboard",
        to: "/dashboard"
    },
    {
        text: "Reservations",
        to: "/reservations"
    },
    {
        text: "Reservation Details",
        active: true
    }
]

/**
 * Breadcrumbs for the new quote page.
 * @type {Array}
 */
export const BREAD_NEW_QUOTE = [
    {
        text: "Dashboard",
        to: "/dashboard"
    },
    {
        text: "Reservations",
        to: "/reservations"
    },
    {
        text: "New Quote",
        active: true
    }
]

/**
 * Breadcrumbs for the edit quote page.
 * @type {Array}
 */
export const BREAD_EDIT_QUOTE = [
    {
        text: "Dashboard",
        to: "/dashboard"
    },
    {
        text: "Reservations",
        to: "/reservations"
    },
    {
        text: "Quote Details",
        active: true
    }
]

/**
 * Sort options for the reservations table.
 * @type {Array}
 */
export const RESERVATION_SORT_OPTIONS = [
    {
        value: "booking_number",
        text: "Ref / ID"
    },
    {
        value: "flightNumber",
        text: "Flight Number"
    },
    {
        value: "from",
        text: "From"
    },
    {
        value: "pickup_date",
        text: "Date & Time"
    },
    {
        value: "invoice",
        text: "Invoice N°"
    },
    {
        value: "passenger",
        text: "Passenger"
    },
    {
        value: "passengersCount",
        text: "N° Passengers"
    },
    {
        value: "status",
        text: "Status"
    },
    {
        value: "payment",
        text: "Payment"
    },
    {
        value: "typeTransfer,",
        text: "Type Transfer,"
    },
    {
        value: "to",
        text: "To"
    },
    {
        value: "created_at",
        text: "Created At"
    }
]

/**
 * Query-param-backed fields on the reservations filters object.
 * @type {Array}
 */
export const RESERVATION_FILTER_FIELDS = [
    "booking_number",
    "date",
    "invoice_number",
    "customer",
    "agent",
    "supplier",
    "service",
    "last_name",
    "first_name",
    "booking_reference",
    "destination",
    "paymentReference",
    "payment_type",
    "dealNumber",
    "firstBooking"
]

/**
 * Status filter options for the reservations status dropdown.
 * @type {Array}
 */
export const RESERVATION_STATUS_FILTERS = [
    { status: "SBC", label: "Cancelled", icon: "flaticon-remove", iconClass: "text-cancelled" },
    { status: "JF", label: "Completed", icon: "flaticon-check", iconClass: "text-completed" },
    { status: "SC", label: "Confirmed", icon: "flaticon-bold-check-3", iconClass: "text-confirmed" },
    { status: "BI", label: "Draft", icon: "flaticon-time-left", iconClass: "text-draft" },
    { status: "EXP", label: "Expired", icon: "flaticon-wall-clock-1", iconClass: "text-cancelled" },
    { status: "NW", label: "New", icon: "flaticon-add", iconClass: "text-new" },
    { status: "NS", label: "No Show", icon: "flaticon-no-group", iconClass: "text-no-show" },
    { status: "SRB", label: "Rejected", icon: "flaticon-warning-1", iconClass: "text-rejected" },
    { status: "PNDG", label: "Pending Payment", icon: "flaticon-wall-clock-1", iconClass: "text-pending" },
    { status: "RCF", label: "Reconfirm", icon: "flaticon-bold-check-3", iconClass: "text-processing" }
]

/**
 * Quote types available for reservations.
 */
export const QUOTE_TYPES = ["CUT_OFF_TIME", "AVAILABILITY_ON_REQUEST"]

/**
 * Capture modes for payment processing.
 * @type {Object}
 */
export const PAYMENT_METHOD = { CREDIT: "CREDIT", STRIPE: "STRIPE" };

/**
 * Capture mode for immediate payment processing.
 * @type {string}
 */
export const CAPTURE_MODE_IMMEDIATE = "IMMEDIATE";

/**
 * Capture mode for deferred payment processing.
 * @type {string}
 */
export const CAPTURE_MODE_DEFERRED = "DEFERRED";

/**
 * Notices shown in the reservation detail's "Important!" section, as
 * `{ title, message }`.
 * @type {Object}
 */
export const RESERVATION_NOTICES = {
    CHANGE_PENDING_PAYMENT: {
        title: "Pending Changes:",
        message: "This reservation has requested changes awaiting payment of the price difference. They will be sent to the supplier for confirmation once the payment is completed."
    },
    CHANGE_PENDING_CONFIRMATION: {
        title: "Pending Changes:",
        message: "This reservation has requested changes awaiting supplier confirmation. The original reservation stays active until the supplier responds."
    },
    AVAILABILITY_REQUEST_PENDING: {
        title: "Availability Request:",
        message: "The supplier is verifying the availability for this request. This quote cannot be modified until the supplier responds."
    }
}

/**
 * Reasons shown when editing a reservation is blocked (Edit button tooltip).
 * @type {Object}
 */
export const EDIT_BLOCKED_REASONS = {
    PENDING_CHANGE: "This reservation cannot be modified while it has pending changes awaiting confirmation.",
    AVAILABILITY_REQUEST_PENDING: "This quote cannot be modified while the supplier is verifying its availability."
}
